export default __webpack_public_path__ + "static/media/img_fee_10.c5b7ff41.svg";